import { useState } from "react";
import Rooms from "./components/Rooms";
import logo from "./LogoD1.png";

export default function App() {
  const [roomId, setRoomId] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState("");

  if (!roomId) {
    return (
      <div style={{ padding: "20px" , textAlign: "center"}}>
        <img
        src={logo}
        alt="Logo"
        style={{ width: "50%", marginBottom: "20px" }}
      />

      <section className="rules" style={{textAlign: "left"}}>
        <h2>Entra in una stanza</h2>
        <p>
          Per iniziare, entra in una stanza: scegli un nome per la stanza e clicca su <strong>Entra</strong>. Assicurati
          che anche tutti gli altri giocatori inseriscano <strong>lo stesso nome di stanza</strong>, così da ritrovarvi
        nello stesso spazio virtuale.</p> 
        <p>
          Esempio:
          L’Araldo crea una stanza chiamata <i>Araldo</i>.
          Rashad, Lily, Pablo ed Elias inseriscono <i>Araldo</i> nel campo <strong>Nome Stanza</strong> e cliccano su
          Entra.
        </p>
      </section>

        <input
          type="text"
          placeholder="Nome stanza..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button
          onClick={() => {
            if (inputValue.trim()) {
              setRoomId(inputValue.trim());
            }
          }}
        >
          Entra
        </button>
      </div>
    );
  }

  // QUI bisogna passare la stanza come prop
  return <Rooms roomId={roomId} />;
}
